import { combineReducers } from 'redux'
import authReducer from './auth.reducer'
import notificationReducer from './notification.reducer'
import brandingReducer from './branding.reducer'
import serviceReducer from './service.reducer'
import { featureFlagsReducer } from './featureFlags.reducer'
import { eventsReducer } from './events.reducer'

export default combineReducers({
    auth: authReducer,
    branding: brandingReducer,
    notifications: notificationReducer,
    service: serviceReducer,
    featureFlags: featureFlagsReducer,
    events: eventsReducer,
})
